export default __webpack_public_path__ + "static/media/ce3.77f63287.jpeg";